// extracted by mini-css-extract-plugin
export default {"wrapper":"YD-z","button":"ZD-z","alternate":"_D-z","disabled":"aE-z","paymentWarning":"bE-z","fadeIn":"cE-z"};